import { NumberField } from "../../../../utils/form";

const DocumentNumberInput = ({ form: { control } }) => (
  <NumberField
    control={control}
    fullWidth
    name="documentNumber"
    label="DNI"
    variant="outlined"
    rules={{ required: true, pattern: { value: /^\d{6,9}$/ } }}
  />
);

export default DocumentNumberInput;